import { RecentCritiquesList } from '../components/composed/RecentCritiquesList/RecentCritiquesList';
import { ErrorBoundary } from '../components/ErrorBoundary';

/**
 * RecentCritiquesPage - Recently Visited Critiques
 * Feature: 067-recent-critiques
 *
 * Displays critique sessions the user has recently visited,
 * excluding sessions on collections they own (those appear in My Critiques).
 *
 * Each session shows:
 * - Collection hero image
 * - Session title
 * - Up to 5 most recent comments
 *
 * Clicking a session navigates to /crit/:sessionId/:slug
 */
export function RecentCritiquesPage() {
  return (
    <ErrorBoundary>
      <RecentCritiquesList />
    </ErrorBoundary>
  );
}
